var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.99609 6C8.99609 7.65685 7.65295 9 5.99609 9C4.33924 9 2.99609 7.65685 2.99609 6C2.99609 4.34315 4.33924 3 5.99609 3C7.65295 3 8.99609 4.34315 8.99609 6Z",
    fill: "#6B6B6B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9961 6C16.9961 7.65685 15.6529 9 13.9961 9C12.3392 9 10.9961 7.65685 10.9961 6C10.9961 4.34315 12.3392 3 13.9961 3C15.6529 3 16.9961 4.34315 16.9961 6Z",
    fill: "#6B6B6B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9252 17C12.9719 16.6734 12.9961 16.3395 12.9961 16C12.9961 14.3648 12.4354 12.8606 11.4958 11.6691C12.2313 11.2435 13.0853 11 13.9961 11C16.7575 11 18.9961 13.2386 18.9961 16V17H12.9252Z",
    fill: "#6B6B6B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.99609 11C8.75752 11 10.9961 13.2386 10.9961 16V17H0.996094V16C0.996094 13.2386 3.23467 11 5.99609 11Z",
    fill: "#6B6B6B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/Users.87e28cbf389b085e97b09f79f8d9f346.svg";
export { ForwardRef as ReactComponent };